"use client"

import * as React from "react"
import Stack from "@mui/material/Stack"
import type { ReactNode } from "react"

const gradientOverlayStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background:
    "linear-gradient(135deg, rgba(59,130,246,0.25) 0%, rgba(236,72,153,0.18) 100%)",
  zIndex: -1,
  pointerEvents: "none",
}

export default function SignInWithBackground({
  children,
}: {
  children: ReactNode
}) {
  const [showBackgroundImage, setShowBackgroundImage] = React.useState(false)

  React.useEffect(() => {
    let cancelled = false
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!cancelled) setShowBackgroundImage(true)
      })
    })
    return () => {
      cancelled = true
      cancelAnimationFrame(id)
    }
  }, [])

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      sx={(theme) => ({
        height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        padding: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
          padding: theme.spacing(4),
        },
        "&::before": showBackgroundImage
          ? {
              content: '""',
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundImage:
                "url(/images/amaurisse/main_amaurisse.webp)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "blur(20px)",
              zIndex: -2,
            }
          : {
              content: '""',
              position: "absolute",
              inset: 0,
              zIndex: -2,
              backgroundImage:
                "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
              backgroundRepeat: "no-repeat",
            },
        "&::after": {
          content: '""',
          ...gradientOverlayStyle,
        },
      })}
    >
      {children}
    </Stack>
  )
}
